import { Box } from '@chakra-ui/react'
import { t } from '@lingui/core/macro'
import { type Filter, useConversations } from 'components/api/useConversations'
import ErrorComponent from 'components/ErrorComponent'
import NoFirstConversation from 'components/NoFirstConversation'
import Conversations from 'components/PreviousConversations/Conversations'
import NoConversations from 'components/PreviousConversations/NoConversations'
import HeaderDivider from 'components/styles/HeaderDivider'
import { usePostHog } from 'posthog-js/react'
import { useEffect, useRef, type FC } from 'react'

import { logEvents } from './copilot/logEvents'

type Props = {
  filter?: Filter
  apiToken: string
  sessionId: string | null
}

const Widget: FC<Props> = ({ filter, apiToken }) => {
  const posthog = usePostHog()
  const dataSent = useRef<boolean>(false)
  const { data, error } = useConversations(apiToken, filter)

  useEffect(() => {
    if (data && dataSent.current === false) {
      posthog?.capture('summary_SummaryOnConversations', {
        numberOfSummaries: data.length,
      })

      logEvents({
        eventType: 'showing summaries page',
        level: 'info',
        numberOfSummaries: data.length,
      })

      dataSent.current = true
    }
  }, [data, posthog])

  if (!data) return <NoFirstConversation />

  return (
    <Box mx="5">
      {error && <ErrorComponent error={error} />}
      {!error && data?.length === 0 && <NoConversations />}
      {data?.length > 0 && (
        <HeaderDivider>🕰️ {t`Previous conversations`} 🕰️</HeaderDivider>
      )}
      {data?.map(([date, conversations]) => (
        <Conversations conversations={conversations} date={date} key={date} />
      ))}
    </Box>
  )
}

export default Widget
